// src/components/divesitedashboard/SystemLimitChip.jsx
import React from "react";
import { Box, Chip } from "@mui/material";

const SystemLimitChip = ({ systemLimit }) => {
  return (
    <Box sx={{ mt: 2, textAlign: "center" }}>
      <Chip
        label={`System limit: ${systemLimit} divesites maximum`}
        color="primary"
        variant="outlined"
        size="small"
      />
    </Box>
  );
};

export default SystemLimitChip;
